import { useEffect } from "react"
import { useHistory } from "react-router"

export const useSyncURL = (id: string) => {
  const history = useHistory()

  useEffect(() => {
    let filteredId = id.toLowerCase()
    var PATTERN = /[^A-Za-z]/g;
    filteredId = filteredId.replace(PATTERN, '')

    const location = history.location.pathname
    if (!location.includes(filteredId)) {

      history.push(`${location}${location === "/" ? "" : "/"}${filteredId}`)
    }

    return () => {
      let location = history.location.pathname
      location = location.replace("/" + filteredId, "")
      history.push(location)
    }
  }, [history, id])
}